(function () {

    var selectors = {
        openSearch: ".search-link .opaque",
        mainSearch: "#searchterm, #searchtermExtra",
        modalSearch: "#ss360-custom-searchbox"
    };

    var eventNamespace = "setupSS360";
    var ss360SearchQueryParam = "ss360Query";
    
    if ($(selectors.mainSearch).length > 0) {
        this.countryCode = AppState.GetCurrentLanguageCode();
        this.removeSS360EventHandlers = () => {
            // We've already set up SS360, so remove any setup listeners
            $(selectors.openSearch).off(`click.${eventNamespace}`);
            $(selectors.mainSearch).off(`keypress.${eventNamespace}`);
        };

        this.addSS360EventHandlers = () => {
            $(selectors.openSearch).on(`click.${eventNamespace}`, this.setupSS360); // For windows greater than 992px
            $(selectors.mainSearch).on(`keypress.${eventNamespace}`, this.setupSS360); // For mobile view
        };

        this.searchSS360Tracking = (searchData = {}) => {
            var { totalResults, query } = searchData;
            window.McTagManager.sendEvent({
                event: "siteSearch",
                searchTerm: query,
                searchResultsCount: totalResults
            });
        };

        this.getSS360Config = () => {
            var isCustomer = window.location.host === "customer.mastercontrol.com";
            var allActiveCountryCodesUpperCase = AppState.AllActiveCountryCodes.map(code => code.toUpperCase());
            
            var countryCodeLowerCase = this.countryCode.toLowerCase();

            var contentGroupsToExclude = [];
            var additionalCss = null;
            if (!isCustomer) {
                contentGroupsToExclude = allActiveCountryCodesUpperCase.filter(code => code !== this.countryCode);
                contentGroupsToExclude.push("Customers");
                contentGroupsToExclude.push("Insider Blog");
                additionalCss = `
                        #unibox-suggest-cluster-heading-${countryCodeLowerCase}, #ss360-heading-${countryCodeLowerCase}{ 
                            display: none;
                        }
                    `;
            }

            if (isCustomer) {   
                contentGroupsToExclude = allActiveCountryCodesUpperCase;
                // ss360Config.contentGroups.include = ["Customers", "Insider Blog", "Other"];
            }

            var ss360Config = {
                siteId: "www.mastercontrol.com",
                language: this.countryCode,
                showErrors: window.location.host !== "www.mastercontrol.com",
                suggestions: {
                    show: true, // whether to show search suggestions
                    maxQuerySuggestions: 6, // the maximum number of query suggestions
                    showImages: false, // show images in search suggestions
                    num: 6, // the maximum number of search suggestions to be shown
                    minChars: 3, // minimum number of characters before the suggestions shows, default: 3,
                    maxWidth: 300, // the maximum width of the suggest box, default: as wide as the input box, at least 275px
                    highlight: true, // whether matched words should be highlighted, default: true
                    mobileScrollOnFocus: true // whether to scroll the page in order for the search box to be to the top of the window (on screens below 768 px)
                },
                style: {
                    themeColor: "#C53494", // the theme color affecting headlines, buttons, and links
                    accentColor: "#3B94A3",
                    loaderType: "square", // can be "skeleton", "cirle" or "square"
                    additionalCss: additionalCss
                },
                searchBox: { selector: selectors.mainSearch },
                results: {
                    //caption: `Found #COUNT# search results for "#QUERY#"`,
                    num: 96, // Total Results to fetch
                    highlightQueryTerms: true, // whether to highlight the query terms in search results
                    //moreResultsButton: "Show more results", // HTML for the more results button, all results will be shown if this is null
                    //noResultsText: "Sorry, we have not found any matches for your query.", // the text to show when there are no results
                    //queryCorrectionText: `Did you mean "#CORRECTION#"?`,
                    searchQueryParamName: ss360SearchQueryParam, // the name of the query string parameter for direct results
                    moreResultsPagingSize: 12, // the number of results to show each time the more results button is pressed (max: 24)
                    redirectOnSingle: false, // whether to redirect instead of showing a single search result
                    lazyLoadImages: true, // whether to lazily load images (once they become nearly visible, instead of loading them all at once)
                    showSearchBoxLayover: true, //whether to show search box in search result layover
                    hideResultsWithoutImage: false // whether to hide all results that don't have any image or have a broken image
                },
                filters: {
                    enabled: true, // whether to generate and show filter options, default: false
                    position: "top", // where to place the filter view, one of the following: "top", "left"; "top" - filters will be shown above the search results, "left" - filters will be shown to the left of search results + "show filter" button will be added for mobile devices
                    label: "Filter", // the label of the filter column, will be also used as screen reader text
                    showCounts: true, // whether to show result counts for multiple choice filters
                    showQuickDelete: true, // whether to show a "Quick Delete" bar summarizing active filter options and providing a "delete all" option
                    deleteAllLabel: "Clear All", // the label of the "delete all" option
                    settings: {} // range filter settings, e.g. {Price: {unit: '$', step: 1, drawHistogram: false}}
                },
                accessibility: {
                    isMainContent: false, // whether to mark ss360 layer as main content of the page
                    resultTopHeadingLevel: 2, // heading level to start with in search result (default h2)
                    suggestHeadingLevel: 2//, // heading level to use in search suggestions, for content group heading
                    //searchFieldLabel: 'Search', // invisible label to be used with screen readers when search field is focused, will only be used if value is not empty and there is no label element associated to the search field,default: 'Search'
                    //srSuggestionsHiddenText: 'Search suggestions are hidden', // text to announce @screen reader after search suggestions have been hidden
                    //srNoSuggestionsText: 'No search suggestions', // text to announce @screen reader if no suggestions are available
                    //srSuggestionsCountText: '#COUNT# search suggestions shown', // text to announce @screen reader after search suggestions have been shown, #COUNT# will be replaced with the suggestion count
                    //srOneSuggestionText: 'One search suggestion shown', // text to announce @screen reader after search suggestions have been shown
                    //srSuggestBoxControlDescription: 'Use up and down arrows to select available result. Press enter to go to selected search result. Touch devices users can use touch and swipe gestures.' // text to announce @screen reader after search input is focused - describes keyboard controls
                },
                contentGroups: { exclude: contentGroupsToExclude },
                tracking: {
                    providers: ["GA"], // how to track, supported values: 'GA' (Google Analytics), 'GTM' (Google Tag Manager)
                    searchCallback: undefined, // callback before SERP is reported, SERP events aren't reported if this returns false, you'll get the query as the parameter for the callback
                    enhanced: true // whether to use the SS360 enhanced, session based tracking to track all search events
                },
                specialMobileSuggest: {
                    enabled: false, // whether to show special mobile suggests, default: false
                    breakpoint: 992, // CSS breakpoint to show mobile suggests (max-width: breakpoint)
                    placeholder: '', // placeholder for empty suggestions
                    searchBoxPlaceholder: '', // the special search box placeholder
                    customTopHtml: '', // additional HTML/text content to be shown above special mobile search field
                    animateTransitions: false, // whether to animate special mobile transitions
                    resizeSearchBoxOnScroll: true, // whether to resize search field when user scrolls special mobile suggests
                    trigger: '#searchterm'
                },
                layout: {
                    mobile: { // below 992px
                        showUrl: true, // whether to show link in search result, default: false
                        showImages: false, // whether to show images in search result, default: true
                        type: 'list', // can be either "grid", "masonry" or "list", default: "list"
                        showSnippet: true, // whether to show text snippet in search result, default: true
                        showTitle: true, // whether to show title in search result, default: true
                        showDataPoints: true, // whether to show data points in search result, default: true
                        gridColsMd: 2, // grid layout column count for devices between 768px and 991px, default: 2
                        gridColsSm: 1 // grid layout column count for devices below 768px, default: 1
                    },
                    desktop: { // 992 px and larger
                        showUrl: true, // whether to show link in search result, default: false
                        showImages: false, // whether to show images in search result, default: true
                        type: 'list', // can be either "grid", "masonry" or "list", default: "list"
                        showSnippet: true, // whether to show text snippet in search result, default: true
                        showTitle: true, // whether to show title in search result, default: true
                        showDataPoints: true, // whether to show data points in search result, default: true
                        gridColsXl: 4, // grid layout column count for devices larger than 1200px, default: 4
                        gridColsLg: 3 // grid layout column count for devices between 992px and 1199px, default: 3
                    }
                },
                callbacks: { postSearch: this.searchSS360Tracking }
            };

        if (this.countryCode !== "US" && !isCustomer) {
                ss360Config.contentGroups.include = [this.countryCode];
            }
            return ss360Config;
        };

        // Sets up Site Search 360 when called
        this.setupSS360 = () => {
            // create a settings object for the search box
            var ss360Config = this.getSS360Config();

            // Not sure if this is even used anymore... 
            var clickSearch = function (clickevent) {
                var e = jQuery.Event("keyup");
                e.key = "Enter";
                $(selectors.mainSearch).trigger(e);
                clickevent.stopPropagation();
                return false;
            };

            // Set variables that SS360 expects to be set on the window variable scope
            window.ss360Config = ss360Config;
            window.clickSearch = clickSearch;

            // Load the library
            $.ajax({
                dataType: "script",
                cache: true,
                url: "https://cdn.sitesearch360.com/v13/sitesearch360-v13.min.js"
            });

            // We've already set up SS360, so remove the listener
            this.removeSS360EventHandlers();
        };

        // We don't need to setup the SS360 functionality unless a search exists in the query string or someone interacts with the search bar
        if (window.location.href.indexOf(ss360SearchQueryParam) > 0) {
            this.setupSS360();
        }
        else {
            this.addSS360EventHandlers();
        }
    }
}.call({}));
